var CUIT = CUIT || {};


CUIT.isValid = function(cuit) {
    //separo cualquier caracter que no tenga que ver con numeros
    cuit = cuit.replace(/[^0-9]/g, "");

    return this._checkLenght(cuit) && this._checkType(cuit) && this._checkCheckSum(cuit);
}

CUIT._checkLenght = function(cuit) {
    return (cuit.length == 11);
}

CUIT._checkType = function(cuit) {
    var code = parseInt(cuit.substr(0, 2), 10);
    var validTypes = [20, 23, 24, 27, 30, 33, 34,50,51,52,53,54,55,56,57,58,59];
    return validTypes.indexOf(code) > -1;
}

CUIT._checkCheckSum = function(sCUIT) {
    var sCUIT = String(sCUIT);
    var aCUIT = sCUIT.split('');

    var aMult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    for (var i = 0; i <= 9; i++) {
        sum += aCUIT[i] * aMult[i];
    }

    var diff = 11 - (sum % 11);
    var checksum = aCUIT[10];

    if (diff == 11) diff = 0; // do not consider diff == 10

    return (diff == checksum);
}

export { CUIT };



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/cuit.js